import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import { Button } from '../../../../components/Marketing/Button/index';
import image1 from './images/image1.png';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container2 = styled(Box)`
  padding: 12px;
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const Container3 = styled(Flex)`
  flex-wrap: wrap;
  margin: 40px auto;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    flex-wrap: initial;
    align-items: center;
    justify-content: center;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const ButtonsContainer = styled(Flex)`
  flex-direction: column;
  margin-top: 24px;
  button {
    width: 100%;
  }
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    flex-direction: column;

    button {
      width: auto;
    }
  }
`;

const ImageContainer = styled(Box)`
  img {
    width: 100%;
  }
`;

const StyledHeader2 = styled.div`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 130%;
  color: #b7bcbd;
`;

const SectionHeading = styled('div')({
  fontWeight: 900,
  fontSize: '36px',
  lineHeight: '120%',
  color: '#16161D',
  paddingBottom: '12px',
});

const SectionDescription = styled('div')({
  fontSize: '16px',
  lineHeight: '140%',
  color: '#707785 ',
});

export const FormalEducation = (): ReactElement => {
  return (
    <Container3>
      <ContainerInner>
        <Container2>
          <StyledHeader2>FORMAL EDUCATION</StyledHeader2>
          <SectionHeading>
            Learn from industry leading institutions
          </SectionHeading>
          <SectionDescription>
            We enable the world’s most passionate, student-centred education
            providers to prepare their learners for the future of work.
          </SectionDescription>
          <ButtonsContainer>
            <Box mb={16}>
              <Button
                variant="primary"
                action={{
                  kind: 'internal_link',
                  value: {
                    link: { to: { type: 'ROUTE_COURSES' } },
                  },
                }}
              >
                Browse courses by institutions
              </Button>
            </Box>
            <Box>
              <Button
                variant="secondary"
                action={{
                  kind: 'internal_link',
                  value: {
                    link: { to: { type: 'ROUTE_PARTNERS_LISTING_PAGE' } },
                  },
                }}
              >
                Learn about partnering with us
              </Button>
            </Box>
          </ButtonsContainer>
        </Container2>
        <ImageContainer>
          <img alt="" src={image1} />
        </ImageContainer>
      </ContainerInner>
    </Container3>
  );
};
